export default __webpack_public_path__ + "static/media/group-13-copy-2.24e0cdb0.svg";